// removed by extract-text-webpack-plugin
module.exports = {"pageSectionForm":"searchpage-module_pageSectionForm_HXWEV"};


//////////////////
// WEBPACK FOOTER
// ./client/components/searchHeader/themes/searchpage.module.css
// module id = 503
// module chunks = 1 3